// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__lmPiz","ant-page-header-heading-title":"styles_ant-page-header-heading-title__nFbWK","table":"styles_table__RuXdY"};